import React from 'react';

import { CheckAccess } from '../components/CheckAccess/CheckAccess';
import { useTranslations } from '../components/Translations/TranslationsProvider';

export const CheckAccessPage = () => {
    const { translations } = useTranslations();

    if (!translations) {
        return null;
    }

    return <CheckAccess translations={translations} />;
};
